import { render, staticRenderFns } from "./PanelCompetitionClassifications.vue?vue&type=template&id=f25a1330&scoped=true&"
import script from "./PanelCompetitionClassifications.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionClassifications.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionClassifications.vue?vue&type=style&index=0&id=f25a1330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25a1330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f25a1330')) {
      api.createRecord('f25a1330', component.options)
    } else {
      api.reload('f25a1330', component.options)
    }
    module.hot.accept("./PanelCompetitionClassifications.vue?vue&type=template&id=f25a1330&scoped=true&", function () {
      api.rerender('f25a1330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionClassifications.vue"
export default component.exports